var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"shueiJinJiouTitle",style:(`background-color: ${_vm.item.bgColor}`)},[_c('h2',{staticClass:"shueiJinJiouTitle__title"},[_vm._v(_vm._s(_vm.item.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }